import type { ResidentialPageLocations } from '@/types/ga4/tracking-locations'

export const RESIDENTIAL_HERO_LOCATION = 'residential_hero'
export const RESIDENTIAL_TESTIMONIALS_LOCATION = 'residential_testimonials'
export const RESIDENTIAL_FAQ_LOCATION = 'residential_faq'
export const RESIDENTIAL_BLOG_CAROUSEL_LOCATION = 'residential_blog_carousel'
export const RESIDENTIAL_CTA_BANNER_LOCATION = 'residential_cta_banner'

export const RESIDENTIAL_PAGE_LOCATIONS = {
	hero: RESIDENTIAL_HERO_LOCATION,
	ctaBanner: RESIDENTIAL_CTA_BANNER_LOCATION,
	testimonials: RESIDENTIAL_TESTIMONIALS_LOCATION,
	faq: RESIDENTIAL_FAQ_LOCATION,
	blogCarousel: RESIDENTIAL_BLOG_CAROUSEL_LOCATION
} as const satisfies ResidentialPageLocations
